export const voiceCalls = {
  "head": {
    "title": "Chamadas",
    "subtitle": "As chamadas que a tua receção telefónica atendeu."
  },
  "stats": {
    "all": "chamada | chamadas",
    "spoken": "atendida | atendidas",
    "inTotal": "no total"
  },
  "toolbar": {
    "searchLabel": "Procurar",
    "searchPlaceholder": "Telefone de quem ligou…",
    "clear": "Limpar a procura",
    "showLabel": "Mostrar",
    "showAll": "Todas as chamadas",
    "showSpoken": "Só as atendidas",
    "showRecorded": "Só as gravadas"
  },
  "notice": {
    "noRecording": "As chamadas não estão a ser gravadas.",
    "noRecordingHow": "Liga «Gravar chamadas» nas definições da tua receção telefónica e, a partir daí, poderás ouvi-las e transcrevê-las aqui."
  },
  "empty": {
    "title": "Ainda não te ligou ninguém",
    "text": "Quando alguém ligar para o teu número, a chamada aparece aqui com quem ligou, quanto durou e o que queria.",
    "filteredTitle": "Não há chamadas com esse filtro",
    "filteredText": "Tenta tirar a procura ou os filtros acima."
  },
  "item": {
    "notSpoken": "Não chegaram a falar",
    "unknownCaller": "Número oculto",
    "linkSent": "Link de reserva enviado",
    "play": "Ouvir a gravação",
    "pause": "Pausa",
    "showTranscript": "Ver a transcrição",
    "hideTranscript": "Ocultar a transcrição",
    "transcribe": "Transcrever e resumir",
    "transcribing": "A transcrever…",
    "noRecordingShort": "Esta chamada não foi gravada",
    "viewReservation": "Ver a reserva",
    "noSummary": "Esta chamada não tem resumo.",
    "copy": "Copiar o número",
    "copied": "Copiado"
  },
  "errors": {
    "load": "Não foi possível carregar as chamadas.",
    "play": "Não foi possível reproduzir a gravação.",
    "transcribe": "Não foi possível pedir a transcrição."
  },
  "table": {
    "call": "Chamada",
    "reservation": "Reserva",
    "listing": "Alojamento",
    "summary": "Resumo",
    "duration": "Duração",
    "date": "Data"
  }
};
